<template>
  <ul class="c-list--checkup">
    <li class="c-list--checkup__item">
      <span class="c-list--checkup__label judgement">判定</span>
      <div class="c-list--checkup__content">
        <p v-if="!hasError">
          サーバーの署名がオフになっています。
        </p>
        <p v-else>
          サーバーの署名がオンになっています。
        </p>
      </div>
    </li>
    <li v-if="detail.tokens" class="c-list--checkup__item">
      <span class="c-list--checkup__label detail">内容</span>
      <div class="c-list--checkup__content">
        <p>{{ detail.tokens }}</p>
      </div>
    </li>
    <li v-if="hasError" class="c-list--checkup__item">
      <span class="c-list--checkup__label hint">ヒント</span>
      <div class="c-list--checkup__content">
        <p>
          Apacheの構成ファイル（httpd.confまたはapache.conf）を開き、ServerSignatureを検索します。
          見つかった場合は、次のように編集します。
        </p>
        <pre
          class="c-text--pre"
        ><code>ServerSignature Off<br />ServerTokens Prod</code></pre>
        <p>
          見つからない場合は、ファイルの最後にこれらの2行を追加してください。<br />構成ファイルを変更した後、Apacheサーバーを再起動する必要があることに注意してください。
        </p>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      required: true
    },
    hasError: {
      type: Boolean,
      required: true
    }
  }
};
</script>
